import { render, staticRenderFns } from "./CampaignChangeOrder.vue?vue&type=template&id=2b2c1430"
import script from "./CampaignChangeOrder.vue?vue&type=script&lang=js"
export * from "./CampaignChangeOrder.vue?vue&type=script&lang=js"
import style0 from "./CampaignChangeOrder.vue?vue&type=style&index=0&id=2b2c1430&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports